import React, { forwardRef } from "react";
import { m } from "motion/react";
import { useAppTheme } from "~/common/hooks/dom/use-app-theme";
import type { ComponentProps } from "react";
import type { ButtonVariants } from "./button.style";
import { buttonStyle } from "./button.style";

interface ButtonProps extends ComponentProps<typeof m.button>, ButtonVariants {
  as?: React.ElementType;
  href?: string;
  dataTestTag?: string;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant,
      className,
      preserveAspectRatio,
      background,
      as: As,
      dataTestTag,
      ...props
    },
    ref,
  ) => {
    const MotionComponent = As ? m(As) : m.button;

    const appTheme = useAppTheme();
    const resolvedBackground =
      background ?? (appTheme === "dark" ? "on-black" : "on-white");

    return (
      <MotionComponent
        type="button"
        {...props}
        ref={ref}
        className={buttonStyle({
          variant,
          className,
          background: resolvedBackground,
          preserveAspectRatio,
        })}
        data-test={dataTestTag ?? "button"}
      />
    );
  },
);

Button.displayName = "Button";

export { Button };
